import { AioExternalReplacements, AitRowGroupData } from "aic";
import { removeStylesFromEditorV3 } from "editor-v3";
import { STYLES_TO_CLEAN, STYLES_TO_DELETE } from "../../../config";
import { removeStylesFromReplacementLists } from "./removeStylesFromReplacementLists";
import { removeStylesFromRow } from "./removeStylesFromRow";

/**
 * Removes Optional and Notes styles from a row group.
 * External lists merge with internal replacements only when they contain styles to remove.
 * When styles are removed from a replacement, its externalName is cleared to break the hierarchy link.
 *
 * @template T - Content type for table cells and comments
 * @param rowGroup - The row group to process
 * @param externalLists - Optional external list replacements to conditionally merge
 * @returns Row group with styles removed from rows, comments, and replacements
 */
export const removeStylesFromRowGroup = <T, R extends AitRowGroupData<T>>(
  rowGroup: R,
  externalLists?: AioExternalReplacements<T>[],
): R => {
  const { processedReplacements } = removeStylesFromReplacementLists(
    rowGroup.replacements,
    externalLists,
  );
  return {
    ...rowGroup,
    rows: rowGroup.rows.map((row) => removeStylesFromRow(row)),
    comments: removeStylesFromEditorV3(rowGroup.comments, STYLES_TO_DELETE, STYLES_TO_CLEAN),
    replacements: processedReplacements,
  };
};
